module.exports = __webpack_public_path__ + "286dd8c8818acc96a902021ebfe24d3f.MP3";